import { authHeader, handleResponse, forDownload } from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function requestSupportFiles(fuseId, logRequestDates) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(logRequestDates),
  };

  const endPoint = `/api/admin/v1/fuses/${fuseId}/files/request`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function cancelSupportFileRequest(fuseId) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  const endPoint = `/api/admin/v1/fuses/${fuseId}/files/cancel-request`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function deleteSupportFiles(fuseId) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  const endPoint = `/api/admin/v1/fuses/${fuseId}/files`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function downloadSupportFile(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...authHeader(),
    },
  };

  const { fuseId, type, fileName } = queryParams;
  const endPoint = `/api/admin/v1/fuses/${fuseId}/files/${type}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(forDownload)
    .then(({ download, url }) => {
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      return download;
    });
}

export const fuseSupportFilesService = {
  requestSupportFiles,
  cancelSupportFileRequest,
  deleteSupportFiles,
  downloadSupportFile,
};
